import type { ReactNode } from 'react'
import { useBillers } from '../api/queries'
import { useAuthenticatedSession } from '../auth/session'
import { AppShell } from './AppShell'
import { BillerSwitcher } from './BillerSwitcher'

/**
 * Supplies the shell's sidebar aside. This seam exists so `AppShell` stays
 * ignorant of how the biller list is fetched — it takes an `aside` node and
 * knows nothing about `/v1/billers`, which is what lets it be tested without
 * a query client mock.
 *
 * `useBillers` is gated on `isInternal`: `/v1/billers` is internal-only and
 * calling it as a biller user is a 403 the UI would then have to swallow, plus
 * a noise entry in the API's audit log for every page load.
 */
export function ShellWithBillers({ children }: { readonly children: ReactNode }) {
  const { user } = useAuthenticatedSession()
  const { data } = useBillers(user.isInternal)

  const billers = (data ?? []).map((b) => ({ id: b.biller_id, name: b.name, kind: b.kind }))

  return (
    <AppShell aside={user.isInternal ? <BillerSwitcher billers={billers} /> : undefined}>
      {children}
    </AppShell>
  )
}
